export interface BankBar {
  bank: string;
  count: number;
}

interface BankBarChartProps {
  data: BankBar[];
}

export default function BankBarChart({ data }: BankBarChartProps) {
  const max = Math.max(1, ...data.map((d) => d.count));
  return (
    <div className="flex flex-col gap-3.5">
      {data.map((d) => {
        const pct = Math.max(2, (d.count / max) * 100);
        return (
          <div key={d.bank} className="flex items-center gap-3">
            <span className="w-40 shrink-0 truncate text-[13px] text-ink">{d.bank}</span>
            <div className="flex h-[26px] flex-1 items-center gap-2">
              <div
                className="h-full rounded-r-[4px] bg-[#1E40AF]"
                style={{ width: `${pct}%` }}
              />
              <span className="shrink-0 text-[13px] font-medium text-ink">{d.count}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}